import { Button } from 'react-bootstrap';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { buildUnitChargeSummary, formatCurrency, formatLeaseRange } from '../unitChargeSummary';

// The archived twin of NewMasterSheet/UnitDetailsModal.js: the same visual language
// (the unit-dlg classes in mastersheet.css), archive-flavored content — Archived On,
// the archive reason, previous versions — and a single action, Preview Tenant.
const formatDmy = (v) => {
  if (!v) return 'N/A';
  const s = String(v).slice(0, 10).split('-');
  return s.length === 3 ? `${s[2]}-${s[1]}-${s[0]}` : 'N/A';
};

const ArchivedUnitDetailsModal = ({ open, onClose, row, tenantName, feeColumns, propertyId, buildingName, onEditTenant }) => {
  if (!row) return null;
  const unitNo = row.unitNo || 'N/A';
  const hasTenant = !!tenantName && tenantName !== 'N/A';
  const { lines, total, deposit, lease } = buildUnitChargeSummary(row, feeColumns);
  const leaseLabel = formatLeaseRange(lease);
  const previousVersions = row.previousVersions || [];

  const preview = (data, e) => {
    e.stopPropagation();
    onClose();
    if (onEditTenant) onEditTenant({ ...data, propertyId, buildingName, isPreviewOnly: true });
  };

  return (
    <Modal isOpen={open} toggle={onClose} centered size="md" fade={false} className="unit-dlg">
      <div className="unit-dlg__head">
        <div className="unit-dlg__head-main">
          <div className="unit-dlg__unit">🏠 Unit {unitNo}</div>
          <div className="unit-dlg__tenant">{hasTenant ? tenantName : 'No tenant on record'}</div>
        </div>
        <div className="unit-dlg__head-right">
          <span className="unit-dlg__pill unit-dlg__pill--archived">Archived</span>
          <button type="button" className="unit-dlg__close" aria-label="Close" onClick={onClose}>×</button>
        </div>
      </div>

      <ModalBody className="unit-dlg__body">
        <div className="unit-dlg__section-label">Monthly Charges (as archived)</div>
        {lines.length > 0 ? (
          lines.map((line) => (
            <div className="unit-dlg__row" key={line.key}>
              <span className="unit-dlg__row-label">{line.label}</span>
              <span className="unit-dlg__row-amt">{formatCurrency(line.amount)}</span>
            </div>
          ))
        ) : (
          <div className="unit-dlg__row unit-dlg__row--empty">No charges on record.</div>
        )}
        <div className="unit-dlg__total">
          <span className="unit-dlg__total-label">Total Monthly</span>
          <span className="unit-dlg__total-amt">{formatCurrency(total)}</span>
        </div>
        <div className="unit-dlg__meta">
          {deposit != null && (
            <span className="unit-dlg__meta-item">Deposit<b>{formatCurrency(deposit)}</b></span>
          )}
          {leaseLabel && (
            <span className="unit-dlg__meta-item">Lease<b>{leaseLabel}</b></span>
          )}
          <span className="unit-dlg__meta-item">Archived On<b>{formatDmy(row.archivedOn)}</b></span>
          <span className="unit-dlg__meta-item">Reason<b>{row.reason || 'N/A'}</b></span>
        </div>
        {previousVersions.length > 0 && (
          <>
            <div className="unit-dlg__section-label" style={{ marginTop: 14 }}>Previous versions</div>
            {previousVersions.map((version, index) => (
              <div className="unit-dlg__row" key={index}>
                <span className="unit-dlg__row-label">Version {index + 1} · {formatDmy(version.createdAt)}</span>
                <Button variant="link" size="sm" className="p-0" onClick={(e) => preview(version, e)}>View</Button>
              </div>
            ))}
          </>
        )}
      </ModalBody>

      <ModalFooter className="unit-dlg__foot">
        <Button color="info" className="unit-dlg__btn" onClick={(e) => preview(row, e)}>👀 Preview Tenant</Button>
      </ModalFooter>
    </Modal>
  );
};

export { ArchivedUnitDetailsModal };
